//POWERED BY LOADSTUDIOS.IO 


//CUSTOMER DATA
async function getCustomerData(customerId) {
  if (!customerId) {
    console.error("Customer ID is missing.");
    return;
  }

  try {
    const response = await fetch(
      `https://yema-secure-api-72c93429e58b.herokuapp.com/get-customer?customerId=${customerId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch loyalty data: ${response.status}`);
    }

    const data = await response.json();
    //console.log("Customer Full Data:", data);

    if (document.getElementById("current-tier")) {
      document.getElementById("current-tier").textContent = `${data.currentTier.title}`;
    }
    if (document.getElementById("points-balance")) {
      document.getElementById("points-balance").textContent = `${data.pointsBalance} points`;
    }
    if (document.getElementById("current-tier-img")) {
      document.getElementById("current-tier-img").src = `${data.currentTier.image}`;
    }

  } catch (error) {
    console.error("Error fetching customer data:", error);
  }
}




//UPDATE INTERCOM

async function getCustomerDataAndUpdateIntercom(customerId) {
  if (!customerId) {
    console.error("Customer ID is missing.");
    return;
  }

  try {
    const response = await fetch(
      `https://yema-secure-api-72c93429e58b.herokuapp.com/get-customer?customerId=${customerId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch loyalty data: ${response.status}`);
    }

    const data = await response.json();
    console.log("Fetched Customer Loyalty Data:", data);

    // Dynamically update window.intercomSettings
    window.intercomSettings = window.intercomSettings || {};
    window.intercomSettings.user_id = customerId; 
    window.intercomSettings.loyalty_tier = data.currentTier.title; 
    window.intercomSettings.loyalty_points = data.pointsBalance;   

    console.log("Updated window.intercomSettings:", window.intercomSettings);

    // Reinitialize Intercom with the updated settings
    if (window.Intercom) {
      window.Intercom("update", window.intercomSettings);
      console.log("Intercom updated successfully with window.intercomSettings.");
    } else {
      console.error("Intercom is not initialized.");
    }
  } catch (error) {
    console.error("Error fetching customer data and updating Intercom:", error);
  }
}


//CUSTOMER REWARD - DASHBOARD
async function getCustomerRewardDashboard(customerId, locale) {
  fetch(
    `https://yema-secure-api-72c93429e58b.herokuapp.com/get-rewards?customerId=${customerId}&locale=${locale}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .then((data) => {
      console.log("Customer Reward Data", data);

      const reward = data.rewards[0];
      let discountCode = null;

      if (reward) {
        discountCode = reward.reward.discountCode;
        discountValue = reward.reward.discountValue;
      }

      if (discountCode) {
        //document.getElementById("discount-code").textContent = `Discount Code: ${discountCode}`;
        document.getElementById("discount-value").textContent = `${discountValue}% Off`
        document.getElementById("apply-discount-btn").style.display = "block";
        document.getElementById("apply-discount-btn").setAttribute("data-discount-code", discountCode);
        document.cookie = `discountCode=${discountCode}; SameSite=None; Secure`;
      } else {
        document.getElementById("discount-code").textContent =
          "No discounts available for this product.";
      }
    })
    .catch((error) => {
      console.log("ERROR Reward data not found", error);
    });
}


// GET CUSTOMER SPENDING
async function getCustomerSpending(customerId, locale, shopButton) {  
  
  fetch(`https://yema-secure-api-72c93429e58b.herokuapp.com/get-spending?customerId=${customerId}&locale=${locale}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(response => response.json())
    .then(data => {
      console.log('Customer Full SPENDING Data', data);
      
      const rulesContainer = document.getElementById('rules-container'); 
      rulesContainer.innerHTML = ''; 
      const rewardCollectionMap = {
        "62043": "https://yema.com/collections/accessories",
        "62048": "https://yema.com/collections/bracelets",
      };

      // Check if data.rules exists and is an array
      if (Array.isArray(data.rules) && data.rules.length > 0) {
        data.rules.forEach(rule => {
          const ruleDiv = document.createElement('div');
          ruleDiv.classList.add('rule-item'); 
          ruleDiv.setAttribute('data-rule-id', rule.id);

          const collectionUrl = rewardCollectionMap[rule.id] || "https://yema.com/collections/watches?filter.p.m.product.caliber_2=Swiss+Made&filter.p.m.product.caliber_2=Other";

          // Set content for each rule
          ruleDiv.innerHTML = `
            <h5 id="reward-category">${rule.title}</h5> 
            <p class="h5" style="margin-bottom:20px">${rule.discountValue}% Off</p>
            <a id="apply-discount-btn" class='redeem-button' href="${collectionUrl}" target="_blank">${shopButton}</a>
          `;

          // Append to the container
          rulesContainer.appendChild(ruleDiv);
        });

      } else {
        // Handle case where no rules are returned
        rulesContainer.innerHTML = '<p>No spending rules available.</p>';
      }
    })
    .catch(error => {
      console.log('ERROR data not found', error);
    });
}

function addRedeemButtonListeners() {
  const buttons = document.querySelectorAll('.redeem-button'); // Use class selector for all buttons
  buttons.forEach(button => {
    button.addEventListener('click', async function() {
      // Find the closest parent ruleDiv and get the data-rule-id
      const ruleDiv = this.closest('.rule-item'); // Use closest to find the rule item
      const ruleId = ruleDiv.getAttribute('data-rule-id'); // Get the ruleId from the ruleDiv
      console.log('Redeem Rule ID:', ruleId);

      // Call the function to apply the reward
      await applyReward(ruleId, customerId);
    });
  });
}


// APPLY RULE REWARD
async function applyReward(ruleId, customerId) {
  try {
    const response = await fetch('https://yema-secure-api-72c93429e58b.herokuapp.com/redeem', {  
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ruleId: ruleId,
        customerId: customerId,
      }),
    });

    const textResponse = await response.text();  // Get raw text response
    console.log('Response Status:', response.status);
    console.log('Raw Response:', textResponse);

    if (response.ok) {
      const result = JSON.parse(textResponse);  // Parse the result if the response is OK
      console.log('Reward applied successfully!', result);
    } else {
      console.error('Failed to apply reward:', textResponse);
    }
  } catch (error) {
    console.error('Error applying reward:', error);
  }
}




